const Department = {

    // FIELDS
    "department": "Department",
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Department",
    "filter_title": "Department Filter",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_description": "Description",
    
    // ERROR
    "error_name": "Enter Department Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

}

export default Department;

